import React from 'react'
import { Box, BoxProps, Grid2 as Grid } from '@mui/material'
import chatBackground from '../../../assets/chat_background.png'
import { useLogo } from 'hooks/useLogo'

const ChatInitialPage: React.FC<BoxProps> = ({ sx, ...props }) => {
  const logo = useLogo()
  return (
    <Box
      {...props}
      sx={{
        ...sx,
        backgroundImage: `url(${chatBackground})`,
        height: '100%'
      }}
    >
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        sx={{
          backgroundColor: 'rgba(0,0,0,0.1)',
          height: '100%'
        }}
      >
        <Box
          component='img'
          src={logo}
          alt='sentinela logo'
          sx={{
            height: 100,
            backgroundColor: 'background.paper',
            borderRadius: '16px',
            '@media(max-width: 895px)': {
              '&': {
                height: 70
              }
            }
          }}
        />
      </Grid>
    </Box>
  )
}

export default ChatInitialPage
